const { makeStyles } = require("@mui/styles");

const useStyles = makeStyles({
  tabBase: {
    marginRight: "20px",
    padding: "0px 10px",
    borderRadius: "5px",
    cursor: 'pointer',
    border: "0.9px solid transparent",
    borderBottom: "4px solid transparent",
  },
  tabActive: {
    border: "0.1px solid #1A73E8",
    borderBottom: "4px solid #1A73E8",
    transition: '0.5s'
  },
});

export default useStyles;
